export default __webpack_public_path__ + "static/media/work1.a553d50c.jpg";